import { Box } from "@chakra-ui/react";

const Verification = () => {
    return <Box>토큰 검증</Box>;
};

export default Verification;
